import styles from './LocationSearchAutocomplete.scss';

import FormHelperText from '@material-ui/core/FormHelperText';
import cx from 'classnames';
import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import TextField, { StandardTextFieldProps } from '@material-ui/core/TextField';

import PlacesAutoComplete from 'react-places-autocomplete';

import poweredByGoogle from './images/powered_by_google_on_white_hdpi.png';

const autocompleteOptions = {
  componentRestrictions: {
    country: 'us',
  },
  types: ['address'],
};

export interface LocationSearchAutocomplete extends StandardTextFieldProps {
  dataTest?: string;
  handleAddressSelect?: (address: string, placeId: string | null) => void;
  handleChange: (value: string) => void;
}

export const LocationSearchAutocomplete = ({
  dataTest,
  handleAddressSelect,
  value,
  name,
  handleChange,
  onBlur,
  error,
  helperText,
  ...props
}: LocationSearchAutocomplete) => {

  return (
    <PlacesAutoComplete
      value={value as string}
      onChange={handleChange}
      onSelect={handleAddressSelect}
      highlightFirstSuggestion
      searchOptions={autocompleteOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <div className={styles.placesAutocomplete}>
          <FormControl
            fullWidth
          >
            <TextField
              {
                ...getInputProps({
                  onBlur,
                  name,
                })
              }
              inputProps={{ 'data-test': dataTest }}
              autoComplete="off"
              error={error}
              {...props}
            />
          </FormControl>
          <FormHelperText error className={styles.placesAutocompleteError}>{helperText}</FormHelperText>
          <div className={styles.placesAutocompleteSuggestions}>
            {suggestions.map(suggestion => {
              const className = cx({
                [styles.placesAutocompleteSuggestionItem]: true,
                [styles.placesAutocompleteSuggestionItemActive]: suggestion.active,
              });
              return (
                <div
                  {...getSuggestionItemProps(suggestion)}
                  className={className}
                  key={suggestion.placeId}
                >
                  <span>{suggestion.description}</span>
                </div>

              );
            })}
            {
              suggestions.length > 0 && (
                <div className={styles.placesAutocompleteDropdownFooter}>
                  <div>
                    <img
                      className={styles.placesAutocompleteDropdownFooterImage}
                      src={poweredByGoogle}
                      alt="Powered by google"
                    />
                  </div>
                </div>
              )
            }
          </div>
        </div>
      )}
    </PlacesAutoComplete>
  );
};
